/**
 * Quotation Service API
 * This is the quotation-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductDto } from './productDto';


export interface QuotationLineDto { 
    id?: number;
    type?: string;
    product?: ProductDto;
    description?: string;
    notes?: string;
    qty?: number;
    unitPrice?: number;
    subTotal?: number;
    vatTotal?: number;
    total?: number;
    deleted?: boolean;
    recommended?: boolean;
    selected?: boolean;
    touched?: boolean;
}

